import React from 'react'
import { formatDateStrShort } from '../../../helpers/FormatDate'
import { statusLabel } from '../../suggestions/suggestions'

interface SuggestedExperienceTableProps {
  items: any[]
  isLoading: boolean
  limit?: number
  onSelectSuggestion: (suggestion: any) => void
}

export const SuggestedExperienceTable: React.FC<SuggestedExperienceTableProps> = ({
  items,
  isLoading,
  limit = 10,
  onSelectSuggestion,
}) => {
  if (isLoading) {
    return (
      <div className='admin-experience-page-table w-100 d-flex'>
        <div className='admin-experience-page-table__column admin-experience-page-table__column--10'>
          <div className='admin-experience-page-table__header'>ID</div>
          {Array.from({ length: limit }).map((_, index) => (
            <div key={`skel-id-${index}`} className='admin-experience-page-table__cell'>
              <span className='skeleton skeleton--text' style={{ width: '60%' }} />
            </div>
          ))}
        </div>
        <div className='admin-experience-page-table__column admin-experience-page-table__column--30'>
          <div className='admin-experience-page-table__header'>NAME</div>
          {Array.from({ length: limit }).map((_, index) => (
            <div key={`skel-title-${index}`} className='admin-experience-page-table__cell'>
              <span className='skeleton skeleton--text' style={{ width: '80%' }} />
            </div>
          ))}
        </div>
        <div className='admin-experience-page-table__column admin-experience-page-table__column--30'>
          <div className='admin-experience-page-table__header'>SUBMITTED BY</div>
          {Array.from({ length: limit }).map((_, index) => (
            <div key={`skel-submitted-${index}`} className='admin-experience-page-table__cell'>
              <span className='skeleton skeleton--text' style={{ width: '70%' }} />
            </div>
          ))}
        </div>
        <div className='admin-experience-page-table__column admin-experience-page-table__column--20'>
          <div className='admin-experience-page-table__header'>DATE UPLOADED</div>
          {Array.from({ length: limit }).map((_, index) => (
            <div key={`skel-date-${index}`} className='admin-experience-page-table__cell'>
              <span className='skeleton skeleton--text' style={{ width: '70%' }} />
            </div>
          ))}
        </div>
        <div className='admin-experience-page-table__column admin-experience-page-table__column--10'>
          <div className='admin-experience-page-table__header'>STATUS</div>
          {Array.from({ length: limit }).map((_, index) => (
            <div key={`skel-status-${index}`} className='admin-experience-page-table__cell'>
              <span className='skeleton skeleton--text' style={{ width: '60%' }} />
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (!items || items.length === 0) {
    return <div className='text-center py-10 text-muted'>No suggestions found.</div>
  }

  return (
    <div className='admin-experience-page-table w-100 d-flex'>
      {/* ID Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--10'>
        <div className='admin-experience-page-table__header'>ID</div>
        {items.map((u, index) => (
          <div
            key={`sug-id-${u.id || index}`}
            onClick={() => onSelectSuggestion(u)}
            className='cursor-pointer admin-experience-page-table__cell admin-experience-page-table__cell--bold'
          >
            {u.id}
          </div>
        ))}
      </div>

      {/* Name Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--30'>
        <div className='admin-experience-page-table__header'>NAME</div>
        {items.map((u, index) => (
          <div
            key={`sug-title-${u.id || index}`}
            onClick={() => onSelectSuggestion(u)}
            className='cursor-pointer admin-experience-page-table__cell admin-experience-page-table__cell--bold'
          >
            {u.title || '—'}
          </div>
        ))}
      </div>

      {/* Submitted By Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--30'>
        <div className='admin-experience-page-table__header'>SUBMITTED BY</div>
        {items.map((u, index) => {
          const submitterName = u.submittedBy?.name || u.submittedBy?.email || '—'
          return (
            <div
              key={`sug-submitter-${u.id || index}`}
              onClick={() => onSelectSuggestion(u)}
              className='cursor-pointer admin-experience-page-table__cell admin-experience-page-table__cell--bold'
            >
              <div className='experience-preview-invited-item'>
                {u.submittedBy?.image && <img src={u.submittedBy.image} alt='' />}
                <div className='text-dark admin-experience-page-table__cell--bold'>
                  {submitterName}
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {/* Date Uploaded Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--20'>
        <div className='admin-experience-page-table__header'>DATE UPLOADED</div>
        {items.map((u, index) => (
          <div
            key={`sug-date-${u.id || index}`}
            onClick={() => onSelectSuggestion(u)}
            className='cursor-pointer admin-experience-page-table__cell admin-experience-page-table__cell--bold'
          >
            {u.createdAt ? formatDateStrShort(u.createdAt) : '—'}
          </div>
        ))}
      </div>

      {/* Status Column (Plain Text) */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--10'>
        <div className='admin-experience-page-table__header'>STATUS</div>
        {items.map((u, index) => (
          <div
            key={`sug-status-${u.id || index}`}
            onClick={() => onSelectSuggestion(u)}
            className='cursor-pointer admin-experience-page-table__cell admin-experience-page-table__cell--bold'
          >
            {u.statusDisplay || statusLabel(u.status)}
          </div>
        ))}
      </div>
    </div>
  )
}
